import React from "react";
import DriveApp from "./DriveApp";
import "../src/component/FileCard.css";
function App() {
  return (
    <div className="App">
      <DriveApp />
    </div>
  );
}

export default App;
